interface SessionStorageKey {
  key: string;
  description: string; //describe what this key stores
  type?: string; //data type this key stores
}

export const SessionStorageKeys: { [name: string]: SessionStorageKey } = {
  IntakeApplicationSessionId: {
    key: 'intakeAppSessionId',
    description: 'AISH Application Session ID issued to non authenticated users',
    type: 'string',
  },
  IntakeApplicationPrescreenData: {
    key: 'intakeAppPrescreenData',
    description: 'AISH Prescreen data to store data to be used in the intake application',
    type: 'Object',
  },
  AuthenticatedApplicationSessionId: {
    key: 'authAppSessionId',
    description: 'AISH Application Session ID issued to authenticated users',
    type: 'string',
  },
  ApplicationVersionReload: {
    key: 'appVersionReload',
    description:
      'AISH Application Reload variable to track tab session reload trigger (fail safe for multiple reloads)',
    type: 'boolean',
  },
};

export const IesSessionStorageKeys: { [name: string]: SessionStorageKey } = {
  IntakeApplicationSessionId: {
    key: 'iesIntakeAppSessionId',
    description: 'IES Application Session ID issued to non authenticated users',
    type: 'string',
  },
  IntakeApplicationPrescreenData: {
    key: 'iesIntakeAppPrescreenData',
    description: 'IES Prescreen data to store data to be used in the intake application',
    type: 'Object',
  },
  AuthenticatedApplicationSessionId: {
    key: 'iesAuthAppSessionId',
    description: 'IES Application Session ID issued to authenticated users',
    type: 'string',
  },
};

export const FbSessionStorageKeys: { [name: string]: SessionStorageKey } = {
  IntakeApplicationSessionId: {
    key: 'fbIntakeAppSessionId',
    description: 'FB Application Session ID issued to non authenticated users',
    type: 'string',
  },
  IntakeApplicationPrescreenData: {
    key: 'fbIntakeAppPrescreenData',
    description: 'FB Prescreen data to store data to be used in the intake application',
    type: 'Object',
  },
  AuthenticatedApplicationSessionId: {
    key: 'fbAuthAppSessionId',
    description: 'FB Application Session ID issued to authenticated users',
    type: 'string',
  },
};

export const FscdIntakeSessionStorageKeys: { [name: string]: SessionStorageKey } = {
  ChildName: {
    key: 'fscdIntakeNewChildNameObj',
    description: 'FSCD Intake new child name object',
    type: 'string',
  },
  IntakeApplicationSessionId: {
    key: 'fscdIntakeAppSessionId',
    description: 'FSCD Application Session ID issued to non authenticated users',
    type: 'string',
  },
  IntakeApplicationPrescreenData: {
    key: 'fscdIntakeAppPrescreenData',
    description: 'FSCD Prescreen data to store data to be used in the intake application',
    type: 'Object',
  },
  AuthenticatedApplicationSessionId: {
    key: 'fscdAuthAppSessionId',
    description: 'FSCD Application Session ID issued to authenticated users',
    type: 'string',
  },
};
